import { ROUTES } from "@/constants";
import { PricingCardProps } from "@/components/screen/global-components/pricing/PricingCard";

export const industryPricingPlansCards: PricingCardProps[] = [
  {
    iconId: "icon-certified-translation_58",
    title: "Standard Translation",
    priceLabel: "$0.10 per word",
    description:
      "Our intelligent platform matches your project to an expert translator specialized in your language pair and use case. Get precision and accuracy across a variety of formats for straightforward translation jobs.",
    buttonPrimaryLabel: "Start order",
    buttonPrimaryHref: ROUTES.startOrder,
    buttonSecondaryLabel: "Learn more",
    buttonSecondaryHref: ROUTES.standardTranslation,
    features: [
      "Simple online ordering",
      "24-hour delivery",
      "Rigorous quality assurance",
      "Expert translators matched to your project needs",
      "24/7 support",
      "Unlimited free revisions",
    ],
  },
  {
    iconId: "icon-enterprise_58",
    title: "Enterprise",
    priceLabel: "Pricing on request",
    description:
      "Custom-fit our energy translation services to your business. This fully managed offering empowers seamless order and delivery across any complexity or volume of translations.",
    buttonPrimaryLabel: "Start order",
    buttonPrimaryHref: ROUTES.startOrder,
    buttonSecondaryLabel: "Learn more",
    buttonSecondaryHref: ROUTES.certifiedTranslation,
    inheritsFrom: "Everything in Standard, plus:",
    features: [
      "Dedicated project manager for personalized service",
      "Bulk ordering with volume-based cost savings",
      "Flexible billing and payment options",
      "White labeling and partner programs available",
      "Coming soon: API and CMS integration",
    ],
  },
];
